<template>
    <v-container>
      <v-text-field
        prefix="Nombre:"
        class="ml-3 mr-3"
        v-model="selectedItem.customized.name"
        single-line
        clearable
        :clear-icon-cb="selectedItem.customized.name == null ? updateEditing(true) : null"
        @click="updateEditing(true)"
      />
      <v-text-field
        prefix="Motor bomba:"
        class="ml-3 mr-3"
        v-model="selectedItem.customized.variable_continuous_running"
        single-line
        clearable
        :clear-icon-cb="selectedItem.customized.variable_continuous_running == null ? updateEditing(true) : null"
        @click="updateEditing(true)"
      />
  
      <v-text-field
        prefix="Bomba alarma:"
        class="ml-3 mr-3"
        v-model="selectedItem.customized.variable_bomb_failure_alarm"
        single-line
        clearable
        :clear-icon-cb="selectedItem.customized.variable_bomb_failure_alarm == null ? updateEditing(true) : null"
        @click="updateEditing(true)"
      />
  
      <v-text-field
        prefix="Orden marcha bomba:"
        class="ml-3 mr-3"
        v-model="selectedItem.customized.variable_run_order"
        single-line
        clearable
        :clear-icon-cb="selectedItem.customized.variable_run_order == null ? updateEditing(true) : null"
        @click="updateEditing(true)"
      />
  
    </v-container>
  </template>
  
  <script>
  import { mapActions, mapState } from "vuex";
  
  export default {
    name: "KoioteBombCanvasQuesosProperties",
  
    computed: {
      ...mapState(["selectedItem"]),
    },
  
    methods: {
      ...mapActions(["updateEditing"]),
  
      isNumber($event) {
        const keyCode = $event.keyCode ? $event.keyCode : $event.which;
        if (keyCode < 48 || keyCode > 57) {
          if (keyCode !== 46) {
            $event.preventDefault();
            return false;
          }
        }
      },
    },
  };
  </script>
  